import React from "react";
import { ReactComponent as UploadExcel } from "../../../Assets/Icons/uploadExcelIcon.svg";
import { ReactComponent as CsvIcon } from "../../../Assets/Icons/csvIcon.svg";
import { ReactComponent as DownloadIcon } from "../../../Assets/Icons/downloadIcon.svg";
import { ReactComponent as CloseIcon } from "../../../Assets/Icons/greyCross.svg";

function CSVUpload({ document: documentName, handleClear, handleAcceptedFiles, offerCodesCount, sampleFileUrl }) {
  const handleSampleDownload = async (event) => {
    // Prevent any parent click/route guards from interpreting this as navigation
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    try {
      // Resolve file URL from public assets or provided URL
      const publicBase = process.env.PUBLIC_URL || '';
      const url = sampleFileUrl || `${publicBase}/sample-offer-codes.csv`;

      // Fetch as blob to avoid SPA navigation and ensure download
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Failed to fetch sample file');
      const blob = await response.blob();

      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = sampleFileUrl ? 'locations.csv' : 'sample-offer-codes.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error('Error downloading sample file:', error);
    }
  };

  return (
    <div className="w-full flex flex-col md:flex-row justify-center items-center gap-2 mt-4">
      {!documentName ? (
        <label
          htmlFor="fileInput"
          className="flex justify-center items-center gap-2 rounded-[5px] border border-[#D9D9D9] w-full md:w-[48%] h-[50px] cursor-pointer bg-white hover:bg-gray-50"
        >
          <UploadExcel />
          <p className="font-poppins font-[500] sm:text-[10px] md:text-[12px] text-[#000000] text-center">
            Upload CSV File
          </p>
        </label>
      ) : (
        <div className="relative flex justify-center items-center rounded-[5px] border border-[#D9D9D9] w-full md:w-[48%] h-[50px] bg-white">
          <div className="flex items-center gap-2">
            <CsvIcon />
            <p className="font-poppins font-[500] sm:text-[10px] md:text-[12px] text-[#000000]">
              {offerCodesCount > 0 ? `Offer Codes (${offerCodesCount})` : 'CSV File Uploaded'}
            </p>
          </div>
          <CloseIcon
            className="cursor-pointer absolute right-3"
            onClick={handleClear}
          />
        </div>
      )}
      <input
        type="file"
        id="fileInput"
        hidden
        accept=".csv, .xls, .xlsx"
        onChange={handleAcceptedFiles}
        onClick={(event) => {
          event.target.value = null;
        }}
      />
      <div
        className="flex justify-center items-center gap-2 rounded-[5px] border border-[#D9D9D9] w-full md:w-[48%] h-[50px] bg-white cursor-pointer hover:bg-gray-50"
        onClick={(e) => handleSampleDownload(e)}
      >
        <CsvIcon />
        <p className="font-poppins font-[500] sm:text-[10px] md:text-[12px] text-[#000000] text-center">
          Sample File
        </p>
        <DownloadIcon />
      </div>
    </div>
  );
}

export default CSVUpload;
